import { MenuGroup } from "./MenuGroup";
import { type MenuGroupConfig } from "./types";

type Props = {
  config: MenuGroupConfig[];
  background?: string;
};

export const GroupedMenu = ({ config, background }: Props) => (
  <div className="flex flex-col gap-4" data-testid="grouped-menu-container">
    {config.map((group) => (
      <MenuGroup
        background={background}
        group={group}
        key={group.section ?? group.items[0]?.label}
      />
    ))}
  </div>
);
